import noop from 'lib/function/noop'
import { createContext } from 'react'

export interface InlineItemCreateContextValue {
  selectedDate: string | undefined
  setDate: (date: string) => void
  clearDate: () => void
}

const InlineItemCreateContext = createContext<InlineItemCreateContextValue>({
  selectedDate: undefined,
  setDate: noop,
  clearDate: noop,
})

export default InlineItemCreateContext
